export default __webpack_public_path__ + "static/media/GroupMNexusLogo.f5ea6dc6.png";